import { FC } from 'react';
import {
  getFocusOnState,
  useFocusSource,
  useIsFocusActive,
} from '@components/MainStage/focusOn.store';
import { Box, Tooltip } from '@mui/material';
import { CrossIcon, FocusOnIcon } from '@utils/iconsDefs';

import { StyledFocusChip } from './FocusOnChip.styled';

const FocusOnChip: FC = () => {
  const isActive = useIsFocusActive();
  const { sourceName } = useFocusSource();

  if (!isActive) return null;

  return (
    <Box px={3} pb={2}>
      <Tooltip title={sourceName ?? ''} placement="right">
        <StyledFocusChip
          icon={<FocusOnIcon width={16} height={16} />}
          label={`Focus on ${sourceName ?? ''}`}
          onDelete={() => getFocusOnState().clear()}
          deleteIcon={<CrossIcon width={16} height={16} />}
        />
      </Tooltip>
    </Box>
  );
};

export default FocusOnChip;
